import * as styles from "./MenuTriggerButton.css";

import { ChevronDown } from "lucide-react";
import type { JSX } from "react";

import { Menu as BaseMenu } from "@base-ui/react/menu";
import { Button } from "@frontend/components/atoms/Button";
import type {
  ButtonSize,
  ButtonVariant,
} from "@frontend/components/atoms/Button/Button.types";

type MenuTriggerButtonProps = Omit<
  React.ComponentProps<typeof BaseMenu.Trigger>,
  "render" | "children"
> & {
  size?: ButtonSize;
  variant?: ButtonVariant;
};

export function MenuTriggerButton({
  size,
  variant,
  ...props
}: MenuTriggerButtonProps): JSX.Element {
  return (
    <BaseMenu.Trigger
      data-slot="menu-trigger-button"
      render={(triggerProps) => (
        <Button size={size} variant={variant} {...triggerProps}>
          <ChevronDown className={styles.chevron} />
        </Button>
      )}
      {...props}
    />
  );
}
